import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';

import { WIDGET_API } from '../../utils';
import { transformWithdrawalRejectRequestResponse } from '../formatters/withdrawalReject';
import type { WithdrawalRejectRequestResponse } from '../models';

export const withdrawalRejectAPI = createApi({
  reducerPath: 'withdrawalRejectAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      withdrawalRejectRequest: builder.query<WithdrawalRejectRequestResponse, void>({
        query: () => 'payments/reverse-pending-withdrawal',
        transformResponse: (response: WithdrawalRejectRequestResponse) =>
          transformWithdrawalRejectRequestResponse(response) as unknown as WithdrawalRejectRequestResponse,
      }),
    };
  },
});

export const { useLazyWithdrawalRejectRequestQuery } = withdrawalRejectAPI;
export default withdrawalRejectAPI.reducer;
